import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import Toolbar from "@mui/material/Toolbar";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { nbfAccountSetting, nbfgetAccountSetting } from "../../../../api/restApi";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AccountSetting = () => {
  const isMediumScreen = useMediaQuery("(min-width: 960px)");
  const [selectedPaymentCash, setSelectedPaymentCash] = useState("");
  const [selectedPaymentBank, setSelectedPaymentBank] = useState("");
  const level3 = useSelector((state) => state.accountLevels.level3);
  let cashDropdown = [];
  let bankDropdown = [];
  console.log(level3, " Levell 3 data");
  // const cashDropdown = ["Cash on hand (Asad)", "Cash on hand (Daniayl)"];
  // const bankDropdown = ["Dubai Islamic Bank", "National Bank ", "Meezan Bank"];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accountData = await nbfgetAccountSetting();
        console.log(accountData);

        if (accountData.PaymentCash) {
          setSelectedPaymentCash(accountData.PaymentCash);
        }
        if (accountData.PaymentBank) {
          setSelectedPaymentBank(accountData.PaymentBank);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const handlePaymentCash = async (event, newValue) => {
    setSelectedPaymentCash(newValue);
  };

  const handlePaymentBank = async (event, newValue) => {
    setSelectedPaymentBank(newValue);
  };

  const handleSubmit = async () => {
    try {
      const accountData = await nbfAccountSetting(
        selectedPaymentCash,
        selectedPaymentBank
      );
      console.log(accountData);
    } catch (error) {
      console.log(error);
    }
  };

  const filterLevel3Data = () => {
    level3.map((level, index) => {
      console.log(level)
      let onHand =
        index % 3 === 0
          ? "Cash on Hand (Asad Riaz),"
          : "Cash on Hand (Wilayat daniyal),";
      let Bank =
        index % 3 === 0
          ? "Mezaan Bank,"
          : index % 2 === 0
          ? "NBP,"
          : "Habib Bank,";
      if (level.type === "BANK") {
        bankDropdown.push(`${level.Discription}   ${level.fullcode}`);
      } else if (level.type === "CASH") {
        cashDropdown.push(`${level.Discription}   ${level.fullcode}`);
      }
    });
  };

  setTimeout(() => {
    filterLevel3Data();
  }, 500);

  return (
    <div>
      <Stack alignItems="center" spacing={1} marginTop="0rem">
        <Box sx={{ flexGrow: 0, padding: { xs: "1rem", md: "1rem" } }}>
          <Grid item xs={24} md={6}>
            <Card
              alignItems="start"
              sx={{
                marginTop: "1rem",
                minWidth: isMediumScreen ? "300%" : "300px"
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    width: "550px",
                    minHeight: "350px",
                    maxHeight: "650px",
                  }}
                >
                  <Toolbar>
                    <Typography
                      sx={{ ml: 2, flex: 1, fontWeight: "bold" }}
                      variant="h6"
                      align="center"
                    >
                      ACCOUNT SETTING
                    </Typography>
                  </Toolbar>

                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                    marginTop="1rem"
                  >
                    <label
                      style={{
                        minWidth: "49%",
                        backgroundColor: "silver",
                        height: "55px",
                      }}
                    >
                      <Typography sx={{ mt: 2, fontSize: "16.5px" }}>
                        Default Cash Account{" "}
                      </Typography>
                    </label>

                    <label style={{ minWidth: "62%" }}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={cashDropdown}
                        sx={{
                          minWidth: 200,
                          display: "flex",
                          justifyContent: "center",
                        }}
                        value={selectedPaymentCash}
                        onChange={handlePaymentCash}
                        renderInput={(params) => (
                          <TextField {...params} label="Select payment" />
                        )}
                      />
                    </label>
                  </Stack>

                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label
                      style={{
                        minWidth: "49%",
                        backgroundColor: "silver",
                        height: "55px",
                      }}
                    >
                      <Typography sx={{ mt: 2, fontSize: "16.5px" }}>
                        Default Bank Account
                      </Typography>
                    </label>

                    <label style={{ minWidth: "62%" }}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={bankDropdown}
                        sx={{
                          minWidth: 200,
                          display: "flex",
                          justifyContent: "center",
                        }}
                        value={selectedPaymentBank}
                        onChange={handlePaymentBank}
                        renderInput={(params) => (
                          <TextField {...params} label="Select payment" />
                        )}
                      />
                    </label>
                  </Stack>

                  <Stack
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label
                      style={{
                        marginLeft: "12rem",
                        marginTop: "2rem",
                        minWidth: "30%",
                      }}
                    >
                      <Button
                        variant="outlined"
                        sx={{ padding: "13px", minWidth: "100%" }}
                        onClick={handleSubmit}
                      >
                        Update
                      </Button>
                    </label>
                  </Stack>

                  <Stack direction={"row"} justifyContent="center"></Stack>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Box>
      </Stack>
    </div>
  );
};

export default AccountSetting;
